import React, { useContext, useState, useRef } from "react";
import PropTypes from "prop-types";
import { Config, I18n, I18nContext } from "@deporvillage/utils-library-component";
import Picture from "@deporvillage/picture-component";

import styles from "./SubscriptionForm.module.scss";

const FormLegalNotice = ({ onOpen, onClose }) => {

    const { translate } = useContext(I18nContext);

    return (
        <div className={ styles['subscription-form-legal-notice-component'] }>
            <div className={ styles['subscription-form-legal-notice-show-more'] }>
                <span className={ styles['show-more'] } onClick={ onOpen } data-testid={ "show-more" }>
                    <I18n>subscribe.legal_notice.show_more</I18n>
                </span>
                <span className={ styles['show-less'] } onClick={ onClose } data-testid={ "show-less" }>
                    <I18n>subscribe.legal_notice.show_less</I18n>
                </span>
            </div>

            <div className={ styles['subscription-form-legal-notice-detail'] }>
                <p>
                    <I18n>subscribe.legal_notice.line_1</I18n>
                </p>
                <p dangerouslySetInnerHTML={ { __html: translate("subscribe.legal_notice.line_2") } }/>
                <p dangerouslySetInnerHTML={ { __html: translate("subscribe.legal_notice.line_3") } }/>
                <p dangerouslySetInnerHTML={ { __html: translate("subscribe.legal_notice.line_4") } }/>
                <p dangerouslySetInnerHTML={ { __html: translate("subscribe.legal_notice.line_5") } }/>
                <p dangerouslySetInnerHTML={ { __html: translate("subscribe.legal_notice.line_6") } }/>
                <p dangerouslySetInnerHTML={ { __html: translate("subscribe.legal_notice.line_7") } }/>
                <p>
                    <span dangerouslySetInnerHTML={ {
                        __html: translate("subscribe.legal_notice.line_8"),
                    } }/>
                    <a href={ translate("subscribe.legal_notice.privacy_policy_link") }
                       rel="nofollow" title={ translate("subscribe.legal_notice.privacy_policy_title") }>
                        <I18n>subscribe.legal_notice.privacy_policy</I18n>
                    </a>
                </p>
            </div>
        </div>
    );
};

FormLegalNotice.propTypes = {
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
};

const SubscriptionForm = ({ withLogo }) => {

    const { url } = useContext(Config);
    const { translate } = useContext(I18nContext);

    const [wasValidated, setWasValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [toggle, setToggle] = useState(false);

    const form = useRef(null);

    const handleSubmit = (e) => {
        if (!form.current.checkValidity()) {
            setWasValidated(true);
            e.preventDefault();
        }
        else setLoading(true);
    };

    const handleClick = () => setIsChecked(!isChecked);

    return (
        <div className={ `${ styles['subscription-form-component'] }${ toggle ? ` ${ styles['toggle'] }` : `` }${ loading ? ` ${ styles['loading'] }` : `` }` } data-testid="subscription-form">
            <form
                className={ `${ styles['subscription-form']}${ wasValidated ? ` ${ styles['was-validated'] }` : `` }` }
                method="post"
                action={ `${ url }/customer/account/createpost` }
                noValidate ref={ form }
            >
                <input type="hidden" name="news_home" />
                <input type="hidden" name="firstname" value="amigo" />
                <input type="hidden" name="lastname" value="amigo" />
                <input type="hidden" name="success_url" value={ `${ url }/customer/account/index/?new=1` }/>
                <input type="hidden" name="error_url" value={ `${ url }/customer/account/newsletter/` }/>

                <header className={ styles['subscription-form-header'] }>
                    { !withLogo ? null :
                        <div className={ styles['logo'] }>
                            <Picture src={ "/static/default/deporvillage_logo.png" } height={ 86 }/>
                        </div>
                    }
                    <p className={ styles['subscription-form-header-title'] }>
                        <span dangerouslySetInnerHTML={ { __html: translate("subscribe.form.title") } }/>
                    </p>
                    <p className={ styles['subscription-form-header-subtitle'] }>
                        <I18n>subscribe.form.subtitle</I18n>
                    </p>
                </header>

                <div className={ styles['subscription-form-input-group'] }>
                    <input type="email" name="email" pattern="^[^@'\x22]+@[^@'\x22]+\.[^@]+$"
                           placeholder={ translate("subscribe.form.email_placeholder") } required autoComplete="email"/>
                    <div className={styles['button-wrapper']}>
                        <button onClick={handleSubmit} className={styles['subscription-group-button']}>
                            <i className={`${styles['icon']} icon icon-arrow-right-keyboard float-right`} />
                            <span><I18n>subscribe.form.cta</I18n></span>
                        </button>
                    </div>
                </div>

                <div className={ `${ styles['subscription-form-check'] }${ isChecked ?  ` ${styles['is-checked'] }` : `` }` }>
                    <input type="checkbox" name="is_subscribed" id="is_subscribed"
                           value={ "1" } defaultChecked={ isChecked } onClick={ handleClick } required/>
                    <label className={ styles['form-check-label'] } htmlFor="is_subscribed">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: translate(
                                    "subscribe.form.accept_terms",
                                    {
                                        general_conditions: translate("subscribe.form.general_conditions"),
                                        privacy_policy: translate("subscribe.form.privacy_policy_link"),
                                    }
                                ),
                            }}
                        />
                    </label>
                    <div className={ styles['wrong-feedback'] }>
                        <I18n>subscribe.form.required_filed</I18n>
                    </div>
                </div>
            </form>
            <div>
                <FormLegalNotice onOpen={ () => setToggle(true) } onClose={ () => setToggle(false) }/>
            </div>
        </div>
    );
};

SubscriptionForm.propTypes = {
    withLogo: PropTypes.bool,
};

export default SubscriptionForm;
